import styled from 'styled-components';

export const StyledStroriesList = styled.section`
    padding: 120px 0 120px;
    position: relative;

	.row{
		
		
	}
    .masonary-row {
        margin-top: 60px;
        div{
            padding-left: 0;
            padding-right: 0;
        }
        @media(max-width: 767px){
            margin-top: 40px;
			padding-left: 15px;
			padding-right: 15px;
			
        }
    }

    .col-md-3 {
        padding-bottom: 60px;
		@media(max-width: 767px){
			padding-bottom: 0;
		}
    }
	
	

`;
